export default [
  {
    action: "manage",
    resource: "all",
    header: "Administració",
  },
  {
    action: "manage",
    resource: "all",
    icon: "HomeIcon",
    title: "Hospedajes",
    route: "foravila-administration-hospedajes-reports",
  },
  {
    action: "manage",
    resource: "all",
    icon: "LayersIcon",
    title: "AEAT",
    route: "foravila-administration-aeat-reports",
  },
  {
    action: "manage",
    resource: "all",
    icon: "Edit3Icon",
    title: "VUD",
    route: "",
    children: [
      {
        title: "Control de registres",
        route: "foravila-administration-vud-numbers",
      },
      {
        title: "Enviament de dades",
        route: "foravila-administration-vud-reports",
      }
    ],
  },
];
